'use strict'
import { cn_balcony_type } from '../model/cn_balcony_type';
//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************
//***********************************************************************************
//**** Tool for generic unserialization of element types
//***********************************************************************************
//***********************************************************************************
//***********************************************************************************

import { cn_beam_column_type } from '../model/cn_beam_column_type';
import { cn_opening_type } from '../model/cn_opening_type';
import { cn_roof_opening_type } from '../model/cn_roof_opening_type';
import { cn_slab_type } from '../model/cn_slab_type';
import { cn_stairs_type } from '../model/cn_stairs_type';
import { cn_wall_type } from '../model/cn_wall_type';
import { cn_pipe_type } from '../model/cn_pipe_type';
import { cn_fence_type } from '../model/cn_fence_type';
import { cn_fence_opening_type } from '../model/cn_fence_opening_type';
import { cn_space_type } from '../model/cn_space_type';
import { logger } from './cn_logger';
import { cn_material_type } from '../model/cn_material_type';
import { cn_ceiling_type } from '../model/cn_ceiling_type';
import { cn_building } from '../model/cn_building';
import { cn_element_type_layer_material } from '../model/cn_element_type_layer_material';
import { cn_molding_type } from '../model/cn_molding_type';
import { cn_niche_type } from '../model/cn_niche_type';
import { cn_mmm_composition } from '../model/cn_mmm_composition';

const serializedUtils = {
    'cn_wall_type': cn_wall_type,
    'cn_opening_type': cn_opening_type,
    'cn_slab_type': cn_slab_type,
    'cn_roof_opening_type': cn_roof_opening_type,
    'cn_beam_column_type': cn_beam_column_type,
    'cn_stairs_type': cn_stairs_type,
    'cn_balcony_type': cn_balcony_type,
    'cn_fence_type': cn_fence_type,
    'cn_pipe_type': cn_pipe_type,
    'cn_fence_opening_type': cn_fence_opening_type,
    'cn_space_type': cn_space_type,
    'cn_material_type': cn_material_type,
    'cn_ceiling_type': cn_ceiling_type,
    'cn_molding_type': cn_molding_type,
    'cn_niche_type': cn_niche_type,
    'cn_mmm_composition': cn_mmm_composition,
};

export class cn_unserialize_element_type {
    constructor() {
    }

    /**
     * @param json
     * @returns {boolean}
     */
    static is_cn_element_type_layer_material(json) {
        return json.class_name == 'cn_wall_type' || json.class_name == 'cn_slab_type' || json.class_name == 'cn_balcony_type' || json.class_name == 'cn_ceiling_type' || json.class_name == 'cn_mmm_composition';
    }

    /**
     * @param {any} json
     * @param {cn_building} building
     */
    static unserialize(json, building = null) {
        const unserializer = serializedUtils[json.class_name];
        if (unserializer) {
            return unserializer.unserialize(json, building);
        } else {
            logger.error(`Unknown element type for unserialization : ${json.class_name}`);
            return null;
        }
    }
}
